import { fetchServer } from "@/features/utils/fetch";
import type { QueryClient } from "@tanstack/react-query";

export class EmailApiClient {
  static async checkAlias(email: string, id?: string) {
    const response = await fetchServer(
      id
        ? `/aliasMail/check_alias_email?contextLegalEntityUuid=${id}`
        : "/aliasMail/check_alias_email",
      {
        method: "POST",
        reloadOn401: false,
        body: {
          email
        }
      }
    );
    if (response.status !== 200) {
      throw new Error("Email already exist");
    }
    const res = await response.json();
    return res as { email: string };
  }

  static async createEmail(queryClient: QueryClient, email: string, id?: string) {
    const response = await fetchServer(
      id ? `/aliasMail/create_new?contextLegalEntityUuid=${id}` : "/aliasMail/create_new",
      {
        method: "POST",
        reloadOn401: false,
        body: {
          email
        }
      }
    );
    if (response.status !== 200) {
      throw new Error("Cannot create new email.");
    }
    queryClient.invalidateQueries({ queryKey: ["user", "profile"] });
    return { success: true, message: "" };
  }
}
